import './components/throttle';
import './components/scrollTo';
import './components/country-gate';
import './components/age-gate';
import './components/barcode-form';
import './components/quiz';
import './components/question';
import './components/participation';

import SmoothScrollMagic from './components/smoothScroll';
let smoothScrollAllPage = new SmoothScrollMagic;
smoothScrollAllPage.init();

const layout = document.querySelector('.layout');

let isTouch = false;
if ('ontouchstart' in document.documentElement) {
    isTouch = true;
}
document.body.className += isTouch ? ' touch' : ' no-touch';

// Mob  menu
(function () {
    let trigger = document.querySelector('.js-menu-trigger');
    let menuOverlay = document.querySelector('.js-header-overlay');
    if (trigger) {
        trigger.onclick = () => {
            document.body.classList.toggle('menu-open');
        };
    }
    if (menuOverlay) {
        menuOverlay.onclick = () => {
            document.body.classList.remove('menu-open');
        };
    }
})();